import { Pipe, PipeTransform } from '@angular/core';
import { DisplayStageNatureTypeDto } from '../../beneficiaries/beneficiary-folder/stages/display-stage-nature-type.dto';

type FilterStageTypePipeArgs = {
  stageNatureType: string;
};

@Pipe({
  name: 'filterStageType',
})
export class FilterStageTypePipe implements PipeTransform {
  transform(stageNatureTypes: DisplayStageNatureTypeDto[], args?: FilterStageTypePipeArgs): DisplayStageNatureTypeDto[] | undefined {
    return stageNatureTypes?.filter((type: DisplayStageNatureTypeDto) => type.nature === args?.stageNatureType);
  }
}
